import { render, staticRenderFns } from "./AssistantForm.vue?vue&type=template&id=0c2d109c&"
import script from "./AssistantForm.vue?vue&type=script&lang=js&"
export * from "./AssistantForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports